/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M13 16h-7a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v1", "key": "svg-0" }], ["path", { "d": "M16 18h6", "key": "svg-1" }], ["path", { "d": "M19 15v6", "key": "svg-2" }]];
const IconCodeVariablePlus = createReactComponent("outline", "code-variable-plus", "CodeVariablePlus", __iconNode);

export { __iconNode, IconCodeVariablePlus as default };
//# sourceMappingURL=IconCodeVariablePlus.mjs.map
